import { render, staticRenderFns } from "./BrandGuidelines.vue?vue&type=template&id=599fbf70&"
import script from "./BrandGuidelines.vue?vue&type=script&lang=js&"
export * from "./BrandGuidelines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports